"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import { useLinkPreviewVariant } from "../LinkPreviewContext";
import { LinkPreviewCardLayout } from "../OpenGraphPreview";
import type { MarketplaceTypePreviewProps } from "./common";
import { getMarketplaceContainerClass, MARKETPLACE_MEDIA_FRAME_CLASS } from "./previewLayout";
export default function MarketplaceUnavailableCard(t0) {
  const $ = _c(21);
  const {
    href,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const variant = useLinkPreviewVariant();
  let relative;
  let t2;
  if ($[0] !== href) {
    relative = removeBaseEndpoint(href);
    t2 = typeof relative === "string" && relative.startsWith("/");
    $[0] = href;
    $[1] = relative;
    $[2] = t2;
  } else {
    relative = $[1];
    t2 = $[2];
  }
  const isRelativeHref = t2;
  const resolvedHref = isRelativeHref ? relative : href;
  const target = isRelativeHref ? undefined : "_blank";
  const rel = isRelativeHref ? undefined : "noopener noreferrer";
  let t3;
  if ($[3] !== compact || $[4] !== variant) {
    t3 = getMarketplaceContainerClass(variant, compact);
    $[3] = compact;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${t3} tw-relative`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={`${MARKETPLACE_MEDIA_FRAME_CLASS} tw-flex tw-items-center tw-justify-center tw-bg-iron-900/50 tw-p-4`} data-testid="marketplace-preview-unavailable-media"><span className="tw-text-center tw-text-sm tw-font-medium tw-text-iron-300">Preview unavailable</span></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== compact) {
    t6 = !compact && <div className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-black/60 tw-px-3 tw-py-2.5" data-testid="marketplace-preview-unavailable-footer"><span className="tw-min-w-0 tw-truncate tw-text-sm tw-font-semibold tw-text-white">Preview unavailable</span><span className="tw-inline-flex tw-size-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/15 tw-bg-black/50 tw-text-white"><svg className="tw-size-3.5 tw-flex-shrink-0" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="3" stroke="currentColor" fill="none" aria-hidden="true"><path d="M55.4,32V53.58a1.81,1.81,0,0,1-1.82,1.82H10.42A1.81,1.81,0,0,1,8.6,53.58V10.42A1.81,1.81,0,0,1,10.42,8.6H32" /><polyline points="40.32 8.6 55.4 8.6 55.4 24.18" /><line x1="19.32" y1="45.72" x2="54.61" y2="8.91" /></svg></span></div>;
    $[7] = compact;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== rel || $[10] !== resolvedHref || $[11] !== t6 || $[12] !== target) {
    t7 = <Link href={resolvedHref} target={target} rel={rel} prefetch={false} className="tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-no-underline">{t5}{t6}</Link>;
    $[9] = rel;
    $[10] = resolvedHref;
    $[11] = t6;
    $[12] = target;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={t4} data-testid="marketplace-preview-unavailable">{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== href || $[18] !== t8 || $[19] !== variant) {
    t9 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t8}</LinkPreviewCardLayout>;
    $[17] = href;
    $[18] = t8;
    $[19] = variant;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}